import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import config from "./config";

const root = createRoot(document.querySelector("#root"));
root.render(  
  <Provider store={store}>
    <GoogleOAuthProvider clientId={config.googleClientID}>
      <App />
    </GoogleOAuthProvider>
  </Provider>);